import {mergeGraph, registerGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('liveFeedGraph', liveFeedGraph);

/* @ngInject */
function liveFeedGraph(GraphService, EssGraphService, locale, defaultGraph, nowIndicatorConfig) {
    const GraphColors = GraphService.colors;

    return mergeGraph(defaultGraph(), nowIndicatorConfig(), {
        size: {
            height: null,
        },
        options: {
            chart: {
                plotBackgroundColor: '#f0efeb',
                marginBottom: 70, // to make space for longer time labels i.e. '17. Aug 02:00'
                marginLeft: 48, // to have the width of the left axis panel fixed
            },
            plotOptions: {
                column: {
                    // To create spacing between adjacent columns
                    borderWidth: 1,
                    grouping: false,
                }
            },
            tooltip: GraphService.getLiveFeedTooltipFormatter([0, 1], locale.getString('graph.kwh'), true)
        },
        xAxis: {
            type: 'datetime',
            labels: {formatter: GraphService.datetimeLabeler()},
            startOfWeek: 1,
            lineWidth: 0,
        },
        yAxis: [
            {
                title: {
                    text: locale.getString('graph.kwh'),
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 5
                },
                gridLineWidth: 0,
                visible: false,
                showFirstLabel: true,
                reversedStacks: false,
                maxPadding: 0.2,
            },
            {
                min: 0,
                max: 120,
                title: {
                    text: '%',
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 20,
                    style: {
                        color: GraphColors.blue
                    }
                },
                labels: {
                    align: 'center',
                    style: {
                        color: GraphColors.blue
                    }
                },
                gridLineWidth: 0,
                opposite: true,
                visible: false,
                showFirstLabel: true,
                endOnTick: false,
                tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            },
            {
                title: {
                    text: 'W',
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 5,
                    style: {
                        color: GraphColors.orange
                    }
                },
                minTickInterval: 1,
                minPadding: 0,
                maxPadding: 0.2, // 20% percent padding
                forceTickAt0: true, // Show tick at 0, and allow negative values
                tickAmount: 7,
                labels: {
                    format: '{value:.0f}',
                    style: {
                        color: GraphColors.orange
                    }
                },
                gridLineWidth: 0,
                showFirstLabel: true,
                visible: false
            },
            {
                title: {
                    text: 'V',
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 25,
                    style: {
                        color: GraphColors.green
                    }
                },
                tickAmount: 10,
                minTickInterval: 0.1,
                labels: {
                    format: '{value:.2f}',
                    style: {
                        color: GraphColors.green
                    }
                },
                maxPadding: 0.2,
                minPadding: 0.2,
                gridLineWidth: 0,
                showFirstLabel: true,
                visible: false
            },
            {
                title: {
                    text: 'A',
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 25,
                    style: {
                        color: GraphColors.orange
                    }
                },
                minPadding: 0,
                maxPadding: 0.2,
                forceTickAt0: true, // Show tick at 0, and allow negative values
                labels: {
                    format: '{value:.2f}',
                    style: {
                        color: GraphColors.orange
                    }
                },
                gridLineWidth: 0,
                showFirstLabel: true,
                visible: false
            }

        ],
        series: [
            {
                yAxis: 0,
                type: 'column',
                name: locale.getString('graph.consumption'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                zIndex: 1,
                pointPadding: 0.2,
                pointPlacement: -0.25,
                visible: false,
                data: [],
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                states: {
                    hover: {
                        color: GraphColors.lightRed,
                        borderColor: GraphColors.lightRed
                    }
                },
                zoneAxis: 'x'
            },
            {
                yAxis: 0,
                color: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE),
                type: 'column',
                name: locale.getString('graph.solar'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                zIndex: 1,
                pointPadding: 0.2,
                pointPlacement: 0.25,
                states: {
                    hover: {
                        color: GraphColors.lightOrange,
                        borderColor: GraphColors.lightOrange,
                    }
                },
                visible: false,
                data: [],
            },
            {
                yAxis: 1,
                lineWidth: 1,
                type: 'line',
                color: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                name: locale.getString('graph.battery_avg'),
                tooltip: {
                    valueSuffix: ' %',
                    valueDecimals: 0,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                zIndex: 4,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightBlue,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 1,
                lineWidth: 0,
                type: 'arearange',
                linkedTo: ':previous',
                color: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                name: locale.getString('graph.battery_range'),
                tooltip: {
                    valueSuffix: ' %',
                    valueDecimals: 0,
                    pointFormatter: GraphService.getTablePointFormatter({range: true})
                },
                fillOpacity: 0.3,
                zIndex: 4,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightBlue,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 2,
                color: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE),
                lineWidth: 1,
                type: 'line',
                name: locale.getString('graph.Pdc'),
                tooltip: {
                    valueSuffix: ' W',
                    valueDecimals: 0,
                    pointFormatter: GraphService.getTablePointFormatter(),
                },
                zIndex: 3,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        colors: GraphColors.lightOrange,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 4,
                color: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE),
                lineWidth: 1,
                type: 'line',
                name: locale.getString('graph.iOI1'),
                tooltip: {
                    valueSuffix: ' A',
                    valueDecimals: 1,
                    pointFormatter: GraphService.getTablePointFormatter(),
                },
                zIndex: 3,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightOrange,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 3,
                color: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                lineWidth: 1,
                type: 'line',
                name: locale.getString('graph.bv'),
                tooltip: {
                    valueSuffix: ' V',
                    pointFormatter: GraphService.getTablePointFormatter(),
                    valueDecimals: 2
                },
                zIndex: 3,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightGreen,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 3,
                lineWidth: 0,
                type: 'arearange',
                linkedTo: ':previous',
                color: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                name: locale.getString('graph.bv_range'),
                tooltip: {
                    valueSuffix: ' V',
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({range:true})
                },
                fillOpacity: 0.3,
                zIndex: 4,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightGreen,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 1,
                color: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                lineWidth: 5,
                type: 'line',
                name: locale.getString('graph.current_battery_level'),
                tooltip: {
                    valueSuffix: ' %',
                    valueDecimals: 0,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: GraphColors.Green})
                },
                zIndex: 5,
                marker: {
                    radius: 4
                },
                states: {
                    hover: {
                        color: GraphColors.lightGreen,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
            {
                yAxis: 0,
                color: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                type: 'column',
                name: locale.getString('graph.generator'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                states: {
                    hover: {
                        color: GraphColors.lightGreen,
                        borderColor: GraphColors.lightGreen
                    }
                },
                zIndex: 1,
                visible: false,
                data: []
            },
            {
                yAxis: 0,
                color: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE, true),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE),
                type: 'column',
                className: 'highcharts-colored-border',
                name: locale.getString('graph.forecasted_solar'),
                data: [],
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: EssGraphService.getColumnColor(EssGraphService.colors.ORANGE), striped:true})
                },
                zIndex: 0,
                pointPadding: 0.2,
                pointPlacement: 0.25,
                states: {
                    hover: {
                        color: EssGraphService.getColumnColor(EssGraphService.colors.LIGHT_ORANGE, true),
                        borderColor: EssGraphService.getColumnColor(EssGraphService.colors.LIGHT_ORANGE)
                    }
                },
                visible: false
            },
            {
                yAxis: 0,
                color: EssGraphService.getColumnColor(EssGraphService.colors.RED, true),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                type: 'column',
                className: 'highcharts-colored-border',
                name: locale.getString('graph.forecasted_consumption'),
                data: [],
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter({overrideColor: EssGraphService.getColumnColor(EssGraphService.colors.RED), striped:true}),
                },
                zIndex: 0,
                pointPadding: 0.2,
                pointPlacement: -0.25,
                states: {
                    hover: {
                        color: EssGraphService.getColumnColor(EssGraphService.colors.LIGHT_RED, true),
                        borderColor: EssGraphService.getColumnColor(EssGraphService.colors.LIGHT_RED)
                    }
                },
                visible: false
            },
            {
                yAxis: 1,
                lineWidth: 1,
                type: 'line',
                dashStyle: 'ShortDash',
                color: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                name: locale.getString('graph.forecasted_battery_avg'),
                tooltip: {
                    valueSuffix: ' %',
                    valueDecimals: 0,
                    pointFormatter: GraphService.getTablePointFormatter({striped:true})
                },
                zIndex: 4,
                marker: {
                    radius: 2
                },
                states: {
                    hover: {
                        color: GraphColors.lightBlue,
                        lineWidth: 1,
                        halo: null
                    }
                },
                visible: false,
                data: []
            },
        ]
    });
}
